import { withInstall } from '../utils'
import _Popover from './Popover'
import './index.scss'

export const Popover = withInstall(_Popover)
export default Popover
